<template>
<svg viewBox="0 0 48 48" fill="none" :class="[`${prefix}-icon`, `${prefix}-icon-mobile-fill`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M38 2c1.105 0 2 .9 2 2v40c0 1.1-.895 2-2 2H10c-1.105 0-2-.9-2-2V4c0-1.1.895-2 2-2h28zM24 34a3 3 0 110 6 3 3 0 010-6z" :fill="useCurrentColor ? 'currentColor' : '#000'"/><path d="M12.5 7.5a1 1 0 011-1h21a1 1 0 011 1v21h-23v-21z" :fill="useCurrentColor ? 'currentColor' : '#fff'"/></svg>
</template>
<script>

export default {
  name: 'IconMobileFill',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
